import Header from "../components/Header";

const Dashboard = () => {
  return <Header title="Dashboard" />;
};

export default Dashboard;
